import { render, staticRenderFns } from "./dataAssetExchangeListing.vue?vue&type=template&id=b54528e6"
import script from "./dataAssetExchangeListing.vue?vue&type=script&lang=js"
export * from "./dataAssetExchangeListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports